import {mapGetters} from 'vuex'

export const eventMixin = {
    computed: {
        ...mapGetters([
            'account',
            'getAgents',
        ]),
    },
    methods: {
        canISellThisEvent: function (event) {
            if(!event.channelCommissions){
                return false
            }

            let filtered = event.channelCommissions.filter(channel => {
                return channel.channelId == this.account.salesChannel.id
            })

            return (filtered.length > 0)? filtered[0].isActive : false
        },
        canAgentSellThisEvent: function (event) {
            if(!event.channelCommissions){
                return false
            }

            let filtered = event.channelCommissions.filter(channel => {
                return channel.channelType == 50
            })

            return (filtered.length > 0)? filtered[0].isActive : false
        },
        canAgentCustomSellThisEvent: function (event) {
            if(!event.salesPermissionsAgentsList || event.salesPermissionsAgentsList.length == 0){
                return false
            }

            return event.salesPermissionsAgentsList.length > 0
        },
        canWidgetSellThisEvent: function (event) {
            if(!event.channelCommissions){
                return false
            }

            let filtered = event.channelCommissions.filter(channel => {
                return channel.channelType == 101
            })

            return (filtered.length > 0)? filtered[0].isActive : false
        },
        eventHasCustomAgents: function (event) {
            return event.salesPermissionsAgentsList && event.salesPermissionsAgentsList.length > 0
        },
        eventPossibleAgentsList: function (event) {
            if(!this.canAgentSellThisEvent(event)){
                // return [] // if agents channel closed the picker shows no agents
                return this.customAgentsArrayMixedWithLabel([]) // if agents channel closed the picker shows all agents but with closed flag
            } else {
                if(this.eventHasCustomAgents(event)){
                    // this allows to show only the agents that are selected (disabled for now, all agents are shown)
                    return this.customAgentsArrayMixedWithLabel(event.salesPermissionsAgentsList)
                    // return this.getAgents
                } else {
                    return this.getAgents
                }
            }
        },
        customAgentsArrayMixedWithLabel: function(customAgentsArray){
            let allAgents = JSON.parse(JSON.stringify(this.getAgents))

            allAgents.map(originalAgent => {
                let addLabel = true
                if(customAgentsArray)
                customAgentsArray.map(allowedAgent => {
                    if(originalAgent.id == allowedAgent.id){
                        addLabel = false
                    }

                })

                if(addLabel){
                    originalAgent.channelClosed = true
                }
            })

            return allAgents
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/event.js